import { useTranslation } from 'react-i18next';
import { ContentContainer } from '../../../../../components/Filters/components/ContentContainer';
import { RadioList } from '../../../../../components/Filters/components/RadioList';
import { useBreakdownsFilterContext } from '../BreakdownsFilterContext';

export const BotsChooser = () => {
  const { t } = useTranslation();
  const { state, updateDraftFilters } = useBreakdownsFilterContext();

  const options = [
    { value: 'include', name: t('Include inauthentic actors') },
    { value: 'exclude', name: t('Exclude inauthentic actors') },
    { value: 'showOnly', name: t('Show only inauthentic actors') },
  ];

  const mapBotsValueToFilterValue = (value) => {
    switch (value) {
      case 'include': return { value: null, exclude: false };
      case 'exclude': return { value: true, exclude: true };
      case 'showOnly': return { value: true, exclude: false };
      default: return { value: null, exclude: false };
    }
  };

  const mapFilterValueToBotsValue = (value, exclude) => {
    if (value === null && exclude === false) return 'include';
    if (value === true && exclude === true) return 'exclude';
    if (value === true && exclude === false) return 'showOnly';
    return 'include';
  };

  const currentBotsValue = mapFilterValueToBotsValue(state.draftFilters.bots.value, state.draftFilters.bots.exclude);
  const selectedOption = options.find(option => option.value === currentBotsValue) || options[0];

  return (
    <ContentContainer>
      <RadioList
        items={options}
        name="breakdown-bots-chooser"
        selectedValue={selectedOption.value}
        onChange={(value) => {
          const filterValue = mapBotsValueToFilterValue(value);
          updateDraftFilters({
            bots: { value: filterValue.value, exclude: filterValue.exclude },
          });
        }}
      />
    </ContentContainer>
  );
};
